import { Head, Banner, Contact } from "../components/Project";
import { Grid, Space, Table } from "../components/Layout";
import { Title, Texts, Media } from "../components/Object";
import { ContactButton } from "../components/Project/Contact";
import { List as PointList } from "../components/Project/Choose";

const Recruit = () => {
  const gridProps = {
    about: {
      dir: ["column", "row"],
      gap: ["80px", "40px"],
      class: "",
      layout: ["510px 1fr", "100%"],
    },
    inner: {
      dir: ["row"],
      gap: 0,
      class: "",
      layout: ["100%"],
    },
  };

  const AboutElm = () => {
    return (
      <div className="l-row">
        <Space size={["160px auto 120px", "80px auto 72px"]}>
          <Grid {...gridProps.about}>
            <Grid {...gridProps.inner}>
              <Title slug="recruit-about" type="single" />
              <Space size={["56px 0 72px", "40px 0 56px"]}>
                <Texts slug="recruit/title"></Texts>
              </Space>
              <Space size={["0 0 64px", "0 0 48px"]}>
                <Texts slug="recruit/body" />
              </Space>

              {/* <Button slug="service" link="/service/" /> */}
            </Grid>

            <Media src="recruit/about" alt="media" class=""></Media>
          </Grid>
        </Space>
      </div>
    );
  };

  const BoxElm = () => {
    const gridProps = {
      button: {
        size: 'fit-content',
        layout: ['repeat(2, 320px)', '100%'],
        dir: ['column', 'row'],
        gap: ['80px', '48px'],
      },
    };

    return (
      <>
        <div className="p-box__wrap">
          <Media
            src="box-back/recruit"
            alt="background"
            class="p-box__img--back"
          ></Media>
          <div className="p-box__wrap--white l-row">
            <div className="p-box__wrap--white__inner">
              <Texts
                slug="recruit/contact-title"
                class="c-text--center c-text--inner-color-dot c-text--med"
              ></Texts>
              <Space size={["72px auto 0", "64px auto 0"]}>
                <Texts slug="recruit/contact-body" class="c-text--med"></Texts>
              </Space>

              <Space size={['0 auto', '0 auto']}>
                <Space size={["80px auto 0", "64px auto 0"]}>
                  <Grid {...gridProps.button}>
                    <ContactButton slug="number"></ContactButton>
                    <ContactButton slug="form"></ContactButton>
                  </Grid>
                </Space>
              </Space>
            </div>
          </div>
        </div>
      </>
    );
  };

  const PointElm = () => {
    const listGroup = "recruit-point";
    return (
      <>
        <Space size={["120px 0 0", "72px 0 0"]}>
          <div className="l-row">
            <Title slug="recruit-point"></Title>

            <Space size={["100px auto 0", "64px auto 0"]}>
              <PointList group={listGroup} length="5"></PointList>
            </Space>
          </div>
        </Space>
      </>
    );
  };

  const TableElm = () => {
    const gridProps = {
      button: {
        size: 'fit-content',
        layout: ['repeat(2, 320px)', '100%'],
        dir: ['column', 'row'],
        gap: ['80px', '48px'],
      },
    };
    return (
      <>
        <Space size={["120px 0 100px", "80px 0 72px"]}>
          <div className="l-row" data-state="min">
            <Title slug="information"></Title>
            <Space size={["100px auto 0", "64px auto 0"]}>
              <Table slug="recruit-list" len="11"></Table>
            </Space>

            <Space size={['0 auto', '0 auto']}>
              <Space size={["80px auto 0", "64px auto 0"]}>
                <Grid {...gridProps.button}>
                  <ContactButton slug="number"></ContactButton>
                  <ContactButton slug="form"></ContactButton>
                </Grid>
              </Space>
            </Space>
          </div>
        </Space>
      </>
    );
  };

  return (
    <>
      <Head slug="recruit"></Head>

      <AboutElm></AboutElm>
      <BoxElm></BoxElm>

      <PointElm></PointElm>

      <TableElm></TableElm>
    
    
      <Banner></Banner>
      <Contact></Contact>
    </>
  );
};

export default Recruit;
